import mockData from './mock.data.document.json';
import mockSearchData from './mock.data.document-search.json';
import { Group, SearchType, GetPolicyDocumentsCallback } from '../../../models/policy-doc-search-types';
import { getGroupsFromDocuments } from '../Functions';

const simulatedDelay = 1000;

export const getMockPolicyDocuments = (
  searchType: SearchType,
  searchTerm: string,
  callBack: GetPolicyDocumentsCallback
) => {
  let documentsData: Group[] = [];

  if (searchType === SearchType.SearchDocumentText && searchTerm) {
    // For mock data - do not return anything for this case
  } else {
    if (searchTerm) {
      documentsData = getGroupsFromDocuments(mockSearchData.policies);
    } else {
      documentsData = mockData.groups as Group[];
    }
  }
  console.log('returning mock data');
  setTimeout(() => {
    callBack(documentsData);
  }, simulatedDelay);
};
